import { makeVar } from '@apollo/client'
import { SignupFormInput } from '../../schemes'

// signUp Form
export const signUpForm = makeVar<
  Omit<SignupFormInput, 'password' | 'repeat_password'> | undefined
>(undefined)
